import React, { useCallback, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { H3 } from '@spark/ui-components/components/Typography';
import ConfirmDeleteModal from '@/containers/UI/Modals/index2';
import { notification } from '@spark/ui-components/utils/notification';
import { deleteTagOuvidoria } from '@spark/services';
import TagsOuvidoriaCadastro from '../Cadastro/index';

const TagsOuvidoriaDetalhes = () => {
  const history = useHistory();
  const { id } = useParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletando, setDeletando] = useState(false);

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/tagsouvidoria/editar/${id}`);
  }, [history, id]);

  const handleConfirmDelete = useCallback(async () => {
    try {
      setDeletando(true);
      await deleteTagOuvidoria(id);
      notification.success('Tag da ouvidoria excluida com sucesso!');
      history.push('/pages/tagsouvidoria');
    } catch (error) {
      console.error('Erro ao excluir tag da ouvidoria:', error);
    } finally {
      setDeletando(false);
      setShowDeleteModal(false);
    }
  }, [history, id]);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Inicio' },
              { name: 'Tags da Ouvidoria' },
              { name: 'Detalhes' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>
                  <H3>Detalhes da Tag da Ouvidoria</H3>
                </CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading
                    variant="outline-danger"
                    onClick={() => setShowDeleteModal(true)}
                  >
                    Excluir
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              <TagsOuvidoriaCadastro isReadOnly={true} id={id} hideHeader={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        loading={deletando}
        title="Excluir Tag da Ouvidoria"
        message="Tem certeza que deseja excluir esta tag da ouvidoria? Esta acao nao pode ser desfeita."
      />
    </Container>
  );
};

export default TagsOuvidoriaDetalhes;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
